import React, { useState, useEffect, useLayoutEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import loader from "../src/assets/loader.gif"
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header/Header";
import ScreenRouter from "./Router/ScreenRouter";
import "react-toastify/dist/ReactToastify.css";
import Megaheader from "./Components/Header/Megaheader";

import "./App.css";
import gsap from 'gsap';

import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
gsap.core.globals("ScrollTrigger", ScrollTrigger)

// Reset scroll to top on route change. This must run in useLayoutEffect,
// not useEffect: useEffect fires after the browser has already painted the
// new page at the OLD scroll position (clamped to the new, shorter page's
// height - which lands on the footer), so the reset would be visible as a
// footer-flash-then-snap-to-top. useLayoutEffect runs before paint, so the
// browser never shows the wrong position in the first place.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => setLoading(false);

    window.addEventListener("load", handleLoad);
    const timeoutId = setTimeout(() => setLoading(false), 4000);

    return () => {
      window.removeEventListener("load", handleLoad);
      clearTimeout(timeoutId);
    };
  }, []);

  // Lock background scroll while the loader is up, until the real page
  // is revealed.
  useEffect(() => {
    document.body.style.overflow = loading ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [loading]);

  return (
    // BrowserRouter/Header/Router/Footer stay mounted at all times - this lets
    // the video and other resources start downloading behind the loader instead
    // of after it, and the page never does the "empty -> full" swap that was
    // causing the footer flash + scroll jump.
    <BrowserRouter>
      <ScrollToTop />
      <Megaheader />
      <div className="">
        <ScreenRouter />
      </div>
      <Footer />

      {loading && (
        <div className="app-boot-loader">
          <img
            src="https://rr-media-files.s3.ap-south-1.amazonaws.com/RR-Logo-Animation_Updated.gif"
            alt="load_image"
            className="hidden sm:block"
          />
          <img
            src="https://rr-media-files.s3.ap-south-1.amazonaws.com/RR-Logo-Animation_Updated_Mobile.gif"
            alt="load_image"
            className="sm:hidden"
          />
        </div>
      )}
    </BrowserRouter>
  );
};

export default App;